<template>
  <v-row>
    <v-col cols="12">
      <template v-if="isGenerated">
        <div class="d-print-none text-right">
          <v-btn
            icon
            class="info--text"
            @click="printRefundReport"
          >
            <v-icon>mdi-printer</v-icon>
          </v-btn>
          <v-btn
            icon
            class="warning--text"
            @click="clear"
          >
            <v-icon>mdi-minus-circle-outline</v-icon>
          </v-btn>
        </div>
        <div class="mt-0 pb-0">
          <h3>
            SALES REFUND REPORT : ( Duration: {{ form.duration | uppercase }}
            <template v-if="form.duration == 'period'">
              {{ form.fromDate }} to {{ form.endDate }}
            </template>
            )
          </h3>
          <h4>Generated At : {{ reference.time }}</h4>
          <h4>Generated By : {{ reference.by }}</h4>
          <img
            :src="reference.barcode"
            class="white pa-1"
          >
        </div>
        <table class="table">
          <thead>
            <tr>
              <th class="text-left">
                Orders
              </th>
              <th class="text-left">
                Items Returned
              </th>
              <th class="text-left">
                Refund Amount
              </th>
              <th class="text-left">
                Total Cost
              </th>
              <th class="text-left">
                Reverted Profit
              </th>
              <th class="text-left">
                Total Tax FALL
              </th>
              <th class="text-left">
                Total Discount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="active">
              <td>{{ refundReport.orders }}</td>
              <td>{{ refundReport.returned }}</td>
              <td>{{ refundReport.refunds | currency }}</td>
              <td>{{ refundReport.cost | currency }}</td>
              <td>{{ refundReport.revertedProfit | currency }}</td>
              <td>{{ refundReport.taxFall | currency }}</td>
              <td>{{ refundReport.revertedDiscount | currency }}</td>
            </tr>
          </tbody>
        </table>
        <table class="table">
          <thead>
            <tr>
              <th class="text-left">
                SALE TRX #
              </th>
              <th class="text-left">
                Returned Items
              </th>
              <th class="text-left">
                Net Cost
              </th>
              <th class="text-left">
                Net Price
              </th>
              <th class="text-left">
                Revert Discount
              </th>
              <th class="text-left">
                Tax Fall
              </th>
              <th class="text-left">
                Reverted Profit
              </th>
              <th class="text-left">
                Total Refunded Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="refund in refundReport.list"
              :key="refund.id"
            >
              <td>
                <img
                  :src="refund.barcode"
                  class="saleBarcode white pa-1"
                >
              </td>
              <td>{{ refund.totalItems }}</td>
              <td>{{ refund.cost | currency }}</td>
              <td>{{ refund.price | currency }}</td>
              <td>{{ refund.discountedAmount | currency }}</td>
              <td>{{ refund.taxAmount | currency }}</td>
              <td>{{ refund.profit | currency }}</td>
              <td>{{ refund.totalAmount | currency }}</td>
            </tr>
          </tbody>
        </table>
      </template>
      <template v-else>
        <v-card outlined>
          <v-card-text>
            <h1><v-icon>mdi-chart-bar</v-icon> Refund Report</h1>
            <v-row class="mt-5 ">
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-select
                  v-model="form.duration"
                  :items="durations"
                  item-text="name"
                  item-value="value"
                  outlined
                  label="Duration"
                  dense
                />
              </v-col>

              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-select
                  v-model="form.way"
                  :items="methods"
                  item-text="name"
                  item-value="value"
                  outlined
                  label="Method"
                  dense
                />
              </v-col>
              <template v-if="form.duration === 'period'">
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="form.fromDate"
                    hide-details="auto"
                    label="Start Date"
                    outlined
                    dense
                    type="date"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="form.endDate"
                    hide-details="auto"
                    label="End Date"
                    outlined
                    type="date"
                    dense
                  />
                </v-col>
              </template>
              <v-col
                cols="12"
                md="4"
                sm="12"
                class="pl-3"
              >
                <v-btn
                  class="warning"
                  @click="generateReport"
                >
                  Generate
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      isGenerated: false,
      durations: [
        { name: "Today's Sale Refunds", value: "today" },
        { name: "This Month Sale Refunds", value: "monthly" },
        { name: "This Year Sale Refunds", value: "yearly" },
        { name: "Specified Period", value: "period" },
      ],
      methods: [
        { name: "Live", value: 1 },
        { name: "Due", value: 0 },
      ],
      form: {
        way: 1,
        duration: "today",
      },
      refundReport: {},
      reference: {},
    };
  },

  methods: {
    clear() {
      Event.$emit("showDrawer");
      this.$data.isGenerated = false;
    },
    printRefundReport() {
      Event.$emit("hideDrawer");
      setTimeout(() => {
        window.print();
      }, 400);
    },
    generateReport() {
      window.axios.post("/refund-report", this.form).then((response) => {
        this.$data.reference = response.data.ref;
        this.$data.refundReport = response.data;
        this.$data.isGenerated = true;
      });
    },
  },
};
</script>
